import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import RelocationAnnouncementModal from "./sections/RelocationAnnouncementModal";
import ConsultationCTA from "./sections/ConsultationCTA";
import TheMysticalAwakeningHero from "./sections/TheMysticalAwakeningHero";
import KitchenOrigins from "./sections/KitchenOrigins";
import Services from "./sections/Services";
import FeaturedMedicalSupplies from "./sections/FeaturedMedicalSupplies";
import CuratedCollections from "./sections/CuratedCollections";
import TheNeighborlyAdvantage from "./sections/TheNeighborlyAdvantage";
import OgrenciVeOgretmenGorusleri from "./sections/OgrenciVeOgretmenGorusleri";
import ExperienceShowcase from "./sections/ExperienceShowcase";
import SariHutFooter from "@/reusable_sections/Footer";
import Transformation from "./sections/Transformation";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <RelocationAnnouncementModal />
      <Transformation />
      <ConsultationCTA />
      <TheMysticalAwakeningHero />
      <KitchenOrigins />
      <Services />
      <FeaturedMedicalSupplies />
      <CuratedCollections />
      <TheNeighborlyAdvantage />
      <OgrenciVeOgretmenGorusleri />
      <ExperienceShowcase />
      <SariHutFooter />
    </div>;
}